import React from 'react'
import './deletePartRequestTCModal.css'
import { Tooltip } from '@mui/material'
export const DeletePartRequestTCModal = ({ TCName, TCDescription, onClose, deleteTC, isTc }) => {

    const handleOkBtn = () => { 
        deleteTC()
        onClose()

    }
    return (
        <section className='delete-TC-cont'>
            <h3>Are you sure you want to  <br /> delete this {isTc ? "TC" : "FND"}?</h3>
            <div className="delete-TC-pCont">
                <p>{isTc ? "TC" : "FND"}: <span>{TCName ? TCName : "--"}</span></p>
                <div>
                    <p >Description:</p>
                    <Tooltip title={TCDescription} arrow>
                        <p tabIndex={0}>{TCDescription}</p>
                    </Tooltip>

                </div>
            </div>
            <div className='delete-TC-btnCont'>
                <button onClick={handleOkBtn}>Ok</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </section>
    )
}
